<template>
  <div class="pages-common-section p-top-xxl-1" :class="{'p-bottom-xxl-1': !props.data.bottomImage}">
    <!-- Section background image -->
    <div v-if="props.data.backgroundImage?.responsiveImage" class="pages-common-section__background-img">
      <WidgetPicture
        class="is-cover"
        :image="{ custom: props.data.backgroundImage?.responsiveImage }"
        :lazyLoad="true"
        :alt="props.data.backgroundImage?.responsiveImage?.alt"
      />
    </div>

    <!-- Section Side Media (only desk) -->
    <div v-if="props.data?.leftMedia" class="pages-common-section__side-media --left show-for-large">
      <WidgetVideo
        v-if="props.data?.leftMedia.videoUrl"
        class="pages-common-section__side-media__video is-cover"
        :videoUrl="props.data?.leftMedia.videoUrl"
        :loop="true"
        :forcePlay="true"
        :autoplay="true"
        :muted="true"
        :controls="false"
      />
      <WidgetPicture
        v-else-if="props.data?.leftMedia?.image?.responsiveImage"
        class="is-cover"
        :image="{ custom: props.data.leftMedia.image.responsiveImage}"
        :lazyLoad="false"
        :alt="props.data?.leftMedia?.image?.responsiveImage?.alt"
      />
    </div>
    <div v-if="props.data?.rightMedia" class="pages-common-section__side-media --right show-for-large">
      <WidgetVideo
        v-if="props.data?.rightMedia.videoUrl"
        class="pages-common-section__video is-cover"
        :videoUrl="props.data?.rightMedia.videoUrl"
        :loop="true"
        :forcePlay="true"
        :autoplay="true"
        :muted="true"
        :controls="false"
      />
      <WidgetPicture
        v-else-if="props.data?.rightMedia?.image?.responsiveImage"
        :image="{ custom: props.data.rightMedia.image.responsiveImage}"
        :lazyLoad="true"
        :alt="props.data?.rightMedia?.image?.responsiveImage?.alt"
      />
    </div>

    <!-- Section main -->
    <div class="pages-common-section__main">
      <!-- Section top image (logo etc..) -->
      <img v-if="props.data.topImage?.url" class="pages-common-section__main__top-img" :src="props.data.topImage.url" :alt="props.data.topImage?.alt" :width="props.data.topImage?.width" :height="props.data.topImage?.height">

      <div v-if="props.data.pretitle" class="pages-common-section__pretitle" v-html="props.data.pretitle" v-anim-reveal-text />
      <div v-if="props.data.title" class="pages-common-section__title title-l-1" v-html="props.data.title" v-anim-reveal-text />
      <div v-if="props.data.subtitle" class="pages-common-section__description text-corpo-xl" v-html="props.data.subtitle" v-anim-reveal-text />

      <!-- Section Main Media (video or image) -->
      <div v-if="props.data.mainMedia?.image || props.data.mainMedia?.videoUrl" class="pages-common-section__main__media" :class="{'--larger': props.data.mainMediaLarger}">
        <WidgetVideo
          v-if="props.data.mainMedia?.videoUrl"
          class="is-cover"
          :videoUrl="props.data.mainMedia?.videoUrl"
          :loop="true"
          :forcePlay="true"
          :autoplay="true"
          :muted="true"
          :controls="false"
        />
        <WidgetPicture
          v-else-if="props.data.mainMedia?.image?.responsiveImage"
          class="is-cover"
          :image="{ custom: props.data.mainMedia?.image?.responsiveImage}"
          :lazyLoad="false"
          :alt="props.data.mainMedia?.image?.responsiveImage?.alt"
        />
      </div> 

      <div v-if="props.data.description" class="pages-common-section__description text-corpo-xl" v-html="props.data.description" v-anim-reveal-text />

      <div v-if="props.data.linkLabel && props.data.linkUrl" class="pages-common-section__cta">
        <WidgetArrowLink
          :label="props.data.linkLabel"
          :link="props.data.linkUrl"
        />
      </div>
    </div>

    <!-- Section bottom image -->
    <div v-if="props.data?.bottomImage?.responsiveImage" class="pages-common-section__bottom-img">
      <WidgetPicture
        :image="{ custom: props.data?.bottomImage?.responsiveImage }"
        :lazyLoad="true"
        :alt="props.data?.bottomImage?.responsiveImage?.alt"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonSection'
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})
</script>

<style lang="scss">
  @import './style.scss';
</style>